import request from '@/utils/request'


// 选择可见范围
export function fetchVisibleRange () {
  return request({
    url: '/v1/post/selectVisibilityType',
    method: 'get',
  }
  )
}
// 选择身份类型
export function fetchIdentityType () {
  return request({
    url: '/v1/user/getNickNameList',
    method: 'get',
  }
  )
}
export function getSayList (params) {
  return request({
    url: '/v1/post/selectCategoryArticle',
    method: 'get',
    params: params
  })
}
// 获取关注的人的同校
export function getFollowSayList (params) {
  return request({
    url: '/v1/post/selectFollowedArticle',
    method: 'get',
    params: params
  })
}
export function sayLike (sayId) {
  return request({
    url: '/v1/say/like',
    method: 'get',
    params: {
      sayId: sayId
    }
  })
}

export function sayComment (data) {
  return request({
    url: '/v1/say/comment',
    method: 'post',
    data
  })
}

export function insertSay (data) {
  return request({
    url: '/v1/say/insertSay',
    method: 'post',
    data
  })
}
// 查询同校热搜
// export function getHotSay () {
//   return request({
//     url: '/v1/post/selectHot',
//     method: 'get',
//   })
// }
export const getHotSay = (params) =>
  request({
    url: '/v1/post/selectHot',
    method: 'get',
    params
  })

// 获取轮播图数据
export const getSwiperData = () => {
  return request({
    url: '/v1/site/carouselPicture',
    method: 'GET',
  })
}
export function fetchArticleList (params) {
  return request({
    url: '/v1/post/selectCategoryArticle',
    method: 'get',
    params: params
  })
}
// 获取推荐的帖子
export function getRecommendArticle (params) {
  return request({
    url: '/v1/post/selectRecommendArticle',
    method: 'get',
    params: params
  })
}
// 获取关注的人发布的帖子
export function getFollowArticle (params) {
  return request({
    url: '/v1/post/selectFollowedArticle',
    method: 'get',
    params: params
  })
}

export function getArticleByUserId (params) {
  return request({
    url: '/v1/post/selectArticleByUserId',
    method: 'get',
    params: params
  })
}
export function deleteMyArticle (id) {
  return request({
    url: '/v1/post/deleteMyArticle',
    method: 'post',
    data: {
      id: id
    }
  })
}
export function getMyArticleInfo (id) {
  return request({
    url: '/v1/post/selectMyArticleInfo',
    method: 'get',
    params: {
      id: id
    }
  })
}

// 搜索页获取热搜内容
export const getHotSearch = (params) => {
  return request({
    url: '/v1/post/selectHot',
    method: 'GET',
    params
  })
}

// 获取搜索历史
export const getSearchList = () => {
  return request({
    url: '/v1/post/selectMySearchHistory',
    method: 'get'
  })
}

// 删除搜索历史
export const deleteSearchHistory = (data) => {
  return request({
    url: '/v1/post/deleteMySearchHistory',
    method: 'post',
    data
  })
}
// export function getHot (type) {
//   return request({
//     url: '/v1/hot',
//     method: 'get',
//     params: {
//       type: type
//     }
//   })
// }

export function articleLike (params) {
  return request({
    url: '/v1/post/like',
    method: 'get',
    params
  })
}
// 获取文章详情接口。
// 注意：每调一次服务端都会记一次阅读量和浏览历史，播放器里每条视频只在第一次切到它时调一次
export function articleInfo (id) {
  return request({
    url: '/v1/post/info',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 视频流：播放器上下切换时加载下一批视频帖（游客也能刷公开视频）。
 *
 * 不用页码：把这次已经出现过的视频 id 带上去，服务端返回「剩下的里面最该看的几条」，
 * 排序分数随时在变，按页码翻会重复或漏条。
 *
 * @param {Object} params
 * @param {Number} [params.type] 0 公开（默认），1 同校（需登录，可带 schoolId）
 * @param {String} [params.schoolId] 同校时的学校
 * @param {String} [params.excludeIds] 已经出现过的视频 id，逗号分隔
 * @param {Number} [params.size] 条数，默认 6、最多 10
 * @returns {Promise} data 为 { records, hasMore }
 */
export function getVideoFeed (params) {
  return request({
    url: '/v1/post/selectVideoFeed',
    method: 'get',
    params
  })
}

/**
 * 生成帖子分享口令文本（含网页版帖子链接）。
 * 文案由服务端拼，前端只在接口失败时退回裸链接
 */
export function getArticleShareText (articleId) {
  return request({
    url: '/v1/post/shareText',
    method: 'get',
    params: { articleId }
  })
}


// 举报帖子
export function reportArticle (data) {
  return request({
    url: '/v1/post/report',
    method: 'post',
    data
  })
}

// 获取举报类型列表
export function getReportTypes () {
  return request({
    url: '/v1/post/reportTypes',
    method: 'get'
  })
}

// 推荐帖子（切换）
export function recommendArticle (params) {
  return request({
    url: '/v1/post/recommend',
    method: 'get',
    params
  })
}

// 不感兴趣（切换）
export function notInterestedArticle (params) {
  return request({
    url: '/v1/post/notInterested',
    method: 'get',
    params
  })
}

// 获取帖子偏好状态
export function getPreferenceStatus (params) {
  return request({
    url: '/v1/post/preferenceStatus',
    method: 'get',
    params
  })
}

/**
 * 参与帖子投票
 *
 * 雪花id超出 JS 安全整数范围，articleId 与 optionIds 都必须以字符串传递，
 * 传数字会在序列化时丢精度，服务端收到的就是另一个id了。
 *
 * @param {Object} data
 * @param {String} data.articleId 帖子id
 * @param {String[]} data.optionIds 所选选项id，单选传一个
 */
export function votePoll (data) {
  return request({
    url: '/v1/post/poll/vote',
    method: 'post',
    data
  })
}

/**
 * 获取帖子投票详情（允许游客访问）
 *
 * 帖子详情/列表接口已经带了 poll 字段，这个接口用于「不重新加载整个帖子
 * 只刷新投票结果」的场景。帖子没有发起投票时 data 为 null。
 *
 * @param {Object} params
 * @param {String} params.articleId 帖子id
 */
export function getPollDetail (params) {
  return request({
    url: '/v1/post/poll/detail',
    method: 'get',
    params
  })
}
